<template>
    <modal name="lot-reminder">
        <div class="fixed z-10 inset-0 overflow-y-auto" aria-labelledby="modal-title" role="dialog" aria-modal="true">
            <div class="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
                <div @click.prevent="$modal.hide('lot-reminder')" class="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" aria-hidden="true"></div>

                <span class="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true">&#8203;</span>

                <transition
                    enter-active-class="ease-out duration-300"
                    enter-from-class="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                    enter-to-class="opacity-100 translate-y-0 sm:scale-100"
                    leave-active-class="ease-in duration-200"
                    leave-from-class="opacity-100 translate-y-0 sm:scale-100"
                    leave-to-class="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95">

                    <div class="inline-block align-bottom bg-white rounded-lg px-4 pt-5 pb-4 text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full sm:p-6">
                        <div class="hidden sm:block absolute top-0 right-0 pt-4 pr-4">
                            <button @click="$modal.hide('lot-reminder')" type="button" class="bg-white rounded-md text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-500">
                                <span class="sr-only">{{ $t('general.close') }}</span>
                                <svg class="h-6 w-6" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
                                </svg>
                            </button>
                        </div>
                        <div class="mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left">
                            <h3 class="text-lg leading-6 font-medium text-gray-900" id="modal-title">Confirmare</h3>
                            <div class="mt-2">
                                <p class="text-sm text-gray-500">
                                    Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.
                                </p>
                            </div>
                            <fieldset class="mt-2 border-t border-b border-gray-200">
                                <legend class="sr-only">Notifications</legend>
                                <div class="divide-y divide-gray-200">
                                    <div class="relative flex items-start py-4">
                                        <div class="min-w-0 flex-1 text-sm">
                                            <label for="comments" class="font-medium text-gray-700">Email</label>
                                            <p id="comments-description" class="text-gray-500">Am email will be sent at {{ obfuscatedEmail }}</p>
                                        </div>
                                        <div class="ml-3 flex items-center h-5">
                                            <input id="comments" aria-describedby="comments-description" name="comments" type="checkbox" class="focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300 rounded">
                                        </div>
                                    </div>
                                    <div class="relative flex items-start py-4">
                                        <div class="min-w-0 flex-1 text-sm">
                                            <label for="candidates" class="font-medium text-gray-700">SMS</label>
                                            <p id="candidates-description" class="text-gray-500">An SMS message will be sent at you phone number ending in {{ obfuscatedPhone }}</p>
                                        </div>
                                        <div class="ml-3 flex items-center h-5">
                                            <input id="candidates" aria-describedby="candidates-description" name="candidates" type="checkbox" class="focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300 rounded">
                                        </div>
                                    </div>
                                    <div class="relative flex items-start py-4">
                                        <div class="min-w-0 flex-1 text-sm">
                                            <label for="offers" class="font-medium text-gray-700">Browser notifications</label>
                                            <p id="offers-description" class="text-gray-500">We will send a browser notification</p>
                                        </div>
                                        <div class="ml-3 flex items-center h-5">
                                            <input v-model="notifications" id="offers" aria-describedby="offers-description" name="offers" type="checkbox" class="focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300 rounded">
                                        </div>
                                    </div>
                                </div>
                            </fieldset>
                            <div class="mt-2">
                                <p class="text-sm text-gray-500">Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua <a target="_blank" href="#">ter</a></p>
                            </div>
                        </div>
                        <div class="mt-5 sm:mt-4 sm:flex sm:flex-row-reverse">
                            <button @click.prevent="bid" type="button" class="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-green-600 text-base font-medium text-white hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500 sm:ml-3 sm:w-auto sm:text-sm">
                                Aminteste-mi sa licitez
                            </button>
                            <button @click.prevent="$modal.hide('lot-reminder')" type="button" class="mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-500 sm:mt-0 sm:w-auto sm:text-sm">
                                {{ $t('general.cancel') }}
                            </button>
                        </div>
                    </div>
                </transition>
            </div>
        </div>
    </modal>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
    data () {
        return {
            sms: false,
            email: false,
            notifications: false,
        }
    },
    watch: {
        notifications(n, o) {
            if(n == true) {
                if (! ("Notification" in window)) {
                    alert("This browser does not support desktop notification");
                    this.notifications = false
                }
                // Let's check whether notification permissions have already been granted
                else if (Notification.permission === "granted") {
                    // If it's okay let's create a notification
                    var notification = new Notification("We'll send you a notification when lot is about to begin");
                }
                // Otherwise, we need to ask the user for permission
                else {
                    Notification.requestPermission().then(function (permission) {
                        // If the user accepts, let's create a notification
                        if (permission === "granted") {
                            var notification = new Notification("We'll send you a notification when lot is about to begin");
                        } else {
                            this.notifications = false
                        }
                    });
                }
            }
        }
    },
    computed: {
        ...mapGetters({
            user: 'getUser',
            auction: 'getAuction',
            auctionCurrentLot: 'getLot',
            selectedLot: 'getSelectedLot',
        }),
        obfuscatedEmail () {
            if(! this.user || !this.user.email) return null

            var splitEmail = this.user.email.split("@")
            var domain = splitEmail[1];
            var name = splitEmail[0];
            return name.substring(0,3).concat(Array(name.length-3).join("*")).concat("@").concat(domain)
        },
        obfuscatedPhone () {
            if(! this.user || !this.user.phone_number) return null
            return this.user.phone_number.slice(-3)
        }
    },
}
</script>
